<ion-header>
    <ion-toolbar>
        <ion-buttons slot="start">
            <ion-button (click)="modalController.dismiss()">
                <ion-icon slot="icon-only" name="arrow-back"></ion-icon>
            </ion-button>
        </ion-buttons>
        <ion-title>Meter Readings</ion-title>
    </ion-toolbar>
</ion-header>

<ion-content>
    <ion-list>
        <ion-item *ngFor="let mr of meterReadingTypes">
            <ion-checkbox slot="start" [(ngModel)]="mr.isChecked"></ion-checkbox>
            <ion-label [color]="mr.isMandatory ? 'danger' : 'black'">{{mr.description}}</ion-label>
            <ion-input type="number" class="ion-text-end" [(ngModel)]="mr.value" [placeholder]="mr.unitDescription"
                       (ionChange)="mr.isChecked = true"></ion-input>
        </ion-item>
    </ion-list>
    <ion-fab vertical="bottom" horizontal="end" slot="fixed">
        <ion-fab-button (click)="addMeterReading()" color="success">
            <ion-icon name="checkmark"></ion-icon>
        </ion-fab-button>
    </ion-fab>
</ion-content>

<ion-footer *ngIf="mandatoryReadings.length > 0" class="ion-text-center">
    <ion-label>Readings in <span style="color: red"><strong>RED</strong></span> are mandatory</ion-label>
</ion-footer>
